import axios from 'axios';
import Cookies from "js-cookie";
import {apiUrl as defaultApiUrl, MajorVersion} from "../config"
import { Subject } from 'rxjs';

export class AuthService
{
    static TOKEN_KEY = "token";
    static EXPIRES_KEY = "expires";
    static VALID_KEY = "valid";
    static FIRSTNAME_KEY = "firstname";
    static SURNAME_KEY = "surname";
    static CUSTOMER_ID_KEY = "customerId";
    static CUSTOMER_NAME_KEY = "customerName";
    static EMAIL_KEY = "email";
    static VALIDCLIENTS = "validClients";
    static USERROLES = "userRoles";
    static ISSSO = "isSSO";
    static ISREADONLY = "isReadOnly";
    static COTQUEUE = "cotQueue"
    static LASTVERSION = "lastUsedVersion"
    static COTSACCESS = "cotsAccess"
    static SECTOR = "sector"


    constructor(apiUrl) {
        this.apiUrl = apiUrl || defaultApiUrl;
    }

    authenticateUser = (email, password) => {
        const payload = {
            "Username": email,
            "Password": password,
            "Version" : MajorVersion
        };
    
        return axios.post(`${this.apiUrl}/Auth/Login`, payload)
            .then((response) =>{
                if(response.status !== 200) { throw new Error(); }
             
                // Store the session token locally
                localStorage.setItem('sessionToken', response.data.sessionId);
                
                // Start a periodic check to validate the session
                this.validateSessionPeriodically(response.data.sessionId);
                
                return response.data;
            })
            .catch((error) => {
                throw new Error("Invalid credentials");
            });
    };
    
    validateSessionPeriodically = (sessionToken) => {
        // Check the session validity every 5 minutes (or whatever interval you prefer)
        setInterval(() => {
            axios.get(`${this.apiUrl}/Auth/ValidateSession/${sessionToken}`)
                .then((response) => {
                    if (!response.data.isValid) {  
                        // If session is not valid, clear the token and log the user out
                        localStorage.removeItem('sessionToken');
                        // Here, you can redirect the user to the login page or show a modal/notification
                        this.clearUserCache();
      
                      

                        window.location.href = '/'; // This will navigate to the root URL.
                                                window.location.reload();
                    }
                });
        }, 300000); // 300000ms = 5 minutes
    };

    authenticateDomainUser = (email, token) => 
    {
      
        const payload = {
            "Username": email,
            "Token": token,
            "Version" : MajorVersion

        };

        return axios.post(`${this.apiUrl}/Auth/LoginDomain`, payload)
            .then((response) =>{

                if(response.status !== 200)
                { throw new Error(); }

                return response.data;
            })
            .catch((error) => {
                throw new Error("Invalid credentials");
            });

    }

    authenticateSSOUser = (email, token,family_name,given_name) => 
    {
        const payload = {
            "Username": email,
            "Token": token,
            "family_name" : family_name,
            "given_name" : given_name,
            "Version" : MajorVersion

        };

        return axios.post(`${this.apiUrl}/Auth/LoginSSO`, payload)
            .then((response) =>{

                if(response.status !== 200)
                { throw new Error(); }

                return response.data;
            })
            .catch((error) => {
                throw new Error("Failed authentication with Inenco services. Please raise a ticket to request the desired access");
            });

    }

  
    authenticateImpersonationDomainUser = (email, token, impersonation) => 
    {
        const payload = {
            "Username": email,
            "Token": token,
            "Impersonation" : impersonation
        };

        return axios.post(`${this.apiUrl}/Auth/LoginDomainImpersonate`, payload)
            .then((response) =>{

                if(response.status !== 200)
                { throw new Error(); }

                return response.data;
            })
            .catch((error) => {
                throw new Error("Invalid credentials");
            });

    }

    isUserAdmin = async () => {
        try {
            console.log('admin checker');
    
            const response = await axios.get(`${this.apiUrl}/Auth/ValidateAdmin/`, this.getConfig());
            return response.data.isAdmin || false; // Return true if admin, false otherwise
        } catch (error) {
            console.error('Error validating admin status:', error);
            return false; // Default to non-admin on error
        }
    };
    
    

    isMultiClient = () => {

        try
        {
            var storedClients = JSON.parse(localStorage.getItem(AuthService.VALIDCLIENTS));
           
            if(storedClients.length > 1)
            {
                return true
            }else
            return false
        }catch
        {
            return false;
        }
      
    }

    isReadOnly = () => {

        try
        {
            const isAdmin = localStorage.getItem(AuthService.ISREADONLY);

            if(isAdmin === 'true')
            { 
                return true 
            
            }    
            else
            {

                return false
            }
        }catch
        {

            return false;
        }
      
    }


    getCotsStatus = () => {
        console.log("localStorage.getItem(AuthService.COTSACCESS)")

        console.log(localStorage.getItem(AuthService.COTSACCESS))
        var accessStatus =  localStorage.getItem(AuthService.COTSACCESS);

        if(!accessStatus || accessStatus === 'undefined')
            return 'none'
        else
            return accessStatus
       
    }

    hasCaseManActive = (clientId) => {

       

        switch (localStorage.getItem(AuthService.CUSTOMER_ID_KEY)) {
            case "366163": //Portal Test
          
                return true;
            default:
                return false;
        }
    }

    hasHHCentActive = (clientId) => {

       

        switch (localStorage.getItem(AuthService.CUSTOMER_ID_KEY)) {
            case "366163": //Portal Test   //case "365882"://Portal Demo
            // case "355645": //Clarion Housing Group Limited (CK 355645)
            // case "148412": //GreenSquareAccord Limited (CK 148412) 
            // case "366052": //GreenSquareAccord Limited South (CK 366052) 
            // case "365519": //Platform Housing Limited (365519)
            // case "149499": //Edge Hill University (CK 149499)
            // case "354454": //Matalan Retail Limited (CK 354454)
            // case "364014": //Thirteen Housing Group Limited (CK 364014) 
            // case "359687": //Bradford District Care Foundation Trust (359687)
                return true;
            default:
                return false;
        }
    }

  

    hasRole = (roleName) => {

        try
        {
            const isAdmin = this.isUserAdmin()
            if(isAdmin === true && roleName !== 'DATAMAPADMIN') //Inenco override
            { return true }          

        var roles = JSON.parse(localStorage.getItem(AuthService.USERROLES));

        if (roles.indexOf(roleName) > -1) {
           return true;
        } else {
            return false;
        }
    }catch
    {
        return false;
    }


    }

    

    validClients = () => {
        var storedClients = JSON.parse(localStorage.getItem(AuthService.VALIDCLIENTS));
        

       return storedClients
    }

    getConfig = () => {
        return {
            headers: {
                'Authorization': `bearer ${localStorage.getItem("token")}`
            }
        };
    };

    addCotQueueItem = (id,siteId,changeReqested,siteAddress,prevQueueId,changeDate) => {
        var cotqueue = JSON.parse(localStorage.getItem(AuthService.COTQUEUE));
        let filtereedArray = cotqueue.filter(cot => cot.id !==prevQueueId);
        filtereedArray.push({id : id, siteId: siteId, changeReqested:changeReqested,  siteAddress:siteAddress, changeDate: changeDate})
        localStorage.setItem(AuthService.COTQUEUE, JSON.stringify(filtereedArray));

    }

    removeCotQueueItem = (id, siteId) => {
        var cotqueue = JSON.parse(localStorage.getItem(AuthService.COTQUEUE));
        let filtereedArray = cotqueue.filter(cot => cot.id !== id);
        localStorage.setItem(AuthService.COTQUEUE, JSON.stringify(filtereedArray));


        if(siteId === 'New')
        {
                return axios.get(`${this.apiUrl}/ServiceManagement/DeleteLogNewSite/${id}`, this.getConfig())
                    .catch()

        }else
        {
            return axios.get(`${this.apiUrl}/ServiceManagement/DeleteLogSiteUpdate/${id}`, this.getConfig())
            .catch()
           
        }


    }

    getCotQueue = () => {
        var cotqueue = JSON.parse(localStorage.getItem(AuthService.COTQUEUE));
        

       return cotqueue
    }


    cacheUserData = (authData) => {
        console.log("authData - HUH")

        console.log(authData)

        localStorage.setItem(AuthService.CUSTOMER_NAME_KEY, authData.clientName);
        localStorage.setItem(AuthService.FIRSTNAME_KEY, authData.firstName);
        localStorage.setItem(AuthService.SURNAME_KEY, authData.surname);
        localStorage.setItem(AuthService.LASTVERSION, authData.lastUsedVersion);
        localStorage.setItem(AuthService.SECTOR, authData.sector);


        localStorage.setItem(AuthService.TOKEN_KEY, authData.token);

        localStorage.setItem(AuthService.EXPIRES_KEY, authData.expiration);
        localStorage.setItem(AuthService.VALID_KEY, true);



        localStorage.setItem(AuthService.CUSTOMER_ID_KEY, authData.clientId);
        
        localStorage.setItem(AuthService.EMAIL_KEY, authData.email);

        
        localStorage.setItem(AuthService.COTQUEUE, JSON.stringify(authData.cotQueue));
        localStorage.setItem(AuthService.VALIDCLIENTS, JSON.stringify(authData.availableClients));
        localStorage.setItem(AuthService.USERROLES, JSON.stringify(authData.roles));
        
        localStorage.setItem(AuthService.ISREADONLY, authData.isReadOnly );


        localStorage.setItem(AuthService.COTSACCESS, authData.cotsAccess);


        Cookies.set('X-Qlik-Session-insite', authData.qsess , { path: '', domain: 'inenco.com' });



       


        return authData;
    };

    clearUserCache = () => {
        localStorage.removeItem(AuthService.TOKEN_KEY);
        localStorage.removeItem(AuthService.EXPIRES_KEY);
        localStorage.removeItem(AuthService.VALID_KEY);
        localStorage.removeItem(AuthService.CUSTOMER_ID_KEY);
        localStorage.removeItem(AuthService.FIRSTNAME_KEY);
        localStorage.removeItem(AuthService.SURNAME_KEY);
        localStorage.removeItem(AuthService.CUSTOMER_NAME_KEY);
        localStorage.removeItem(AuthService.EMAIL_KEY);
        localStorage.removeItem(AuthService.VALIDCLIENTS);
        localStorage.removeItem(AuthService.ISREADONLY);
        localStorage.removeItem(AuthService.COTQUEUE);
        localStorage.removeItem(AuthService.LASTVERSION);

        localStorage.removeItem(AuthService.COTSACCESS);
        localStorage.removeItem(AuthService.SECTOR);



        Cookies.remove('X-Qlik-Session-insite');

        localStorage.clear(); 
        sessionStorage.clear()
        

    };

    updateCustomerName = (customerName) => {
        localStorage.setItem(AuthService.CUSTOMER_NAME_KEY, customerName);

        return;
    }

    updateSSOLogin = (value) => 
    {
        localStorage.setItem(AuthService.ISSSO, value);
        return;
    }

    changeCustomer = (customerId, customerName) => {
        const isAdmin = this.isUserAdmin()
        if(!isAdmin){
            console.warn("Only admins can change customer Id");
            return;
        }

        localStorage.setItem(AuthService.CUSTOMER_ID_KEY, customerId);
        localStorage.setItem(AuthService.CUSTOMER_NAME_KEY, customerName);
    };

    hasUserDataExpired = () => {
        const expiry = this.getUserData(AuthService.EXPIRES_KEY);

        if(expiry == null)
        { return false; }

        const currentDate = new Date().toISOString();
        return expiry < currentDate;
    };

    getUserData = (key) => {
        return localStorage.getItem(key);
    };


    // ... Timeout after Inactivity ...
    inactivityTimer = null;
    graceTimer = null;
    inactivitySubject = new Subject();
  
    startInactivityTimer = () => {
      this.resetInactivityTimer();
      document.addEventListener('mousemove', this.resetInactivityTimer);
      document.addEventListener('keypress', this.resetInactivityTimer);
    }
  
    resetInactivityTimer = () => {
      if (this.inactivityTimer) clearTimeout(this.inactivityTimer);
      if (this.graceTimer) clearTimeout(this.graceTimer);
  
      this.inactivityTimer = setTimeout(() => {
        this.inactivitySubject.next(true);
        this.startGraceTimer();
      }, 60 * 60 * 1000); // 60 minutes 
    }
  
    startGraceTimer = () => {
      this.graceTimer = setTimeout(() => {
        this.logoutUser();
      }, 10 * 60 * 1000); // 10 minutes grace period
    }
  
    logoutUser = () => {
      this.clearUserCache();
      // Redirect to logout page or show login modal
      window.location.href = '/logout';
    }



}